import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../axios";

// Фолбэк на случай, когда бэкенд недоступен: страница услуг не должна
// выглядеть пустой. Держим здесь две ключевые услуги Kazakh Japan — виза и
// гид-сопровождение, — а не абстрактные примеры: человек, попавший на сайт в
// момент недоступности API, всё равно понимает, чем компания занимается.
const sampleServices = [
    {
        _id: "s1",
        name: {
            ru: "Виза в Японию",
            en: "Japan Visa",
            kk: "Жапонияға виза",
        },
        description: {
            ru: "Берём все бюрократические процессы на себя — от подготовки пакета документов до подачи в Консульство Японии.",
            en: "We handle the whole bureaucracy — from preparing your documents to filing them at the Consulate of Japan.",
            kk: "Барлық бюрократиялық үдерісті өз мойнымызға аламыз — құжаттарды дайындаудан бастап Жапония Консулдығына тапсыруға дейін.",
        },
        price: "50 000 ₸",
        imageUrl: "",
    },
    {
        _id: "s2",
        name: {
            ru: "Услуги гида-сопровождающего",
            en: "Guide and Escort",
            kk: "Гид-сүйемелдеуші қызметі",
        },
        description: {
            ru: "Русскоязычный гид в Японии: помогает с транспортом, языком и бытом, чтобы поездка шла без стресса.",
            en: "A Russian-speaking guide in Japan: transport, language and everyday logistics sorted, so the trip runs stress-free.",
            kk: "Жапониядағы орыс тілді гид: көлік, тіл және тұрмыстық мәселелерді шешіп, саяхатты күйзеліссіз өткізуге көмектеседі.",
        },
        price: "По запросу",
        imageUrl: "",
    },
];
export const fetchServices = createAsyncThunk("services/fetchServices", async () => {
    try {
        const { data } = await axios.get("/services");
        return data;
    } catch (error) {
        console.error("Failed to fetch services from server. Using sample data instead.", error);
        return sampleServices;
    }
});

export const fetchRemoveServices = createAsyncThunk("services/fetchRemoveServices", async (id) => {
    axios.delete(`/services/${id}`);
});

const initialState = {
    services: {
        items: [],
        status: "loading",
    },
};

const servicesSlice = createSlice({
    name: "services",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchServices.pending, (state) => {
                state.services.items = [];
                state.services.status = "loading";
            })
            .addCase(fetchServices.fulfilled, (state, action) => {
                state.services.items = action.payload;
                state.services.status = "loaded";
            })
            .addCase(fetchServices.rejected, (state) => {
                state.services.items = [];
                state.services.status = "error";
            })
            .addCase(fetchRemoveServices.pending, (state, action) => {
                state.services.items = state.services.items.filter(
                    (obj) => obj._id !== action.meta.arg
                );
            });
    },
});

export const servicesReducer = servicesSlice.reducer;
